<!-- 我的担保 -->
<template>
  <div id="loan-list-bl">
    <section class="loan-lists">
      <router-view></router-view>
    </section>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as types from '../../vuex/types/type';
import MyLoanApi from '../../api/personalCenter/myloan_bl.js';

export default {
  data () {
    return {
      myLoanData: {
        whblfSum: 0,
        yhbjSum: 0,
        yhfwfSum: 0,
        yhSum: 0,
        limitMoneySum: 0,
        whbjSum: 0,
        whSum: 0,
        limitUsedSum: 0,
        whfwfSum: 0,
        allReceivableAmountSum: 0,
        yhblfSum: 0,
        limitAvailableSum: 0,
        showList: []
      }
    };
  },

  methods: {
    getInfo () {
      MyLoanApi.getMyBlItemInfoCount({
        tokenId: localStorage.getItem('dl_tokenId_bl')
      })
        .then((res) => {
          if (res.rspcode == 1) {
            this.myLoanData.whblfSum = res.data.whblfSum;
            this.myLoanData.yhbjSum = res.data.yhbjSum;
            this.myLoanData.yhfwfSum = res.data.yhfwfSum;
            this.myLoanData.yhSum = res.data.yhSum;
            this.myLoanData.whSum = res.data.whSum;
            this.myLoanData.showList = res.data.showList;
            this.myLoanData.limitMoneySum = res.data.limitMoneySum;
            this.myLoanData.whbjSum = res.data.whbjSum;
            this.myLoanData.limitUsedSum = res.data.limitUsedSum;
            this.myLoanData.whfwfSum = res.data.whfwfSum;
            this.myLoanData.allReceivableAmountSum =
              res.data.allReceivableAmountSum;
            this.myLoanData.yhblfSum = res.data.yhblfSum;
            this.myLoanData.limitAvailableSum = res.data.limitAvailableSum;
          } else {
          }
        })
        .catch((error) => {});
    },
  },
  mounted () {
    this.getInfo();
    this.$router.push({
      path: '/personalCenter/myGuarantor/guarantorList',
      query: { frontApplyState: 'all', pageCount: 1, applyState: 'all' }
    });
  }
};
</script>
<style lang='scss'>
#loan-list-bl {
  position: relative;
  left: 20px;
  .info-amount {
    width: 100%;
    background-color: #fff;
    height: 70px;
    color: #3e454d;
    font-size: 14px;
    margin-top: 20px;
    overflow: hidden;
    .info-amount-item {
      width: 25%;
      float: left;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      overflow: hidden;
      .info-amount-first {
        width: 100%;
        text-align: center;
        // flex: 1;
      }
      .info-amount-money {
        margin-top: 10px;
        display: inline-block;
        color: #EB662B;
        overflow: hidden;
        width: 100%;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .info-amount-long {
        padding-left: 60%;
      }
      .vertical-line {
        position: absolute;
        right: 0;
        top: 0px;
        margin-top: 18px;
        width: 1px;
        height: 30px;
        border-right: 1px solid #e8e8e8;
      }
    }
  }
  .info-amount-second {
    margin-top: 0;
  }
}

.amount {
  overflow: hidden;
  .amount-item {
    display: inline-block;
    height: 187px;
    width: 437px;
    overflow: hidden;
    margin-left: 11px;
    background: #fff url("../../../static/images/Columns.png") no-repeat center 126px;

    &:first-child {
      margin-left: 0;
    }

    .amount-title {
      margin-top: 40px;
      font-size: 18px;
      color: #333;
      font-family: "FZLanTingHei-DB-GBK";
    }

    .amount-title-en {
      margin-top: 7px;
      font-size: 13px;
      color: #3e454d;
      font-family: "MyriadPro-Regular";
    }

    .amount-money {
      margin-top: 10px;
      font-size: 25px;
      color: #34495E;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 28px;
      em {
        font-style: normal;
        font-family: "Microsoft YaHei";
      }
    }
  }

  span {
    display: block;
    width: 100%;
    text-align: center;
  }
}

 .is-useing-limit {
  .amount-item {
    width: 207px;
    margin-left: 15px;
    background: #fff url("../../../static/images/Columns.png") no-repeat center 144px;
    .ask-amount-btn {
      width: 92px;
      height: 30px;
      display: block;
      margin: 15px auto;
      border-radius: 2px;
      cursor: pointer;
      background: $orange;
      line-height: 30px;
      font-size: 14px;
      color: $white;
      font-family: "FZLanTingHei-B", "Microsoft YaHei";
    }
  }
  .amount-item:nth-child(even) {
    background: #fff url("../../../static/images/Columns.png") no-repeat center 144px;
  }
}

.amount,
.info-card,
.loan-lists {
  position: relative;
  margin-top: 20px;
  width: 100%;
}

.info-card,
.repayment-amount,
.outstanding-amount,
.loan-lists {
  border-radius: 2px;
  background: #fff;
}

.loan-lists {
  margin-bottom: 20px;
}

.info-card {
  height: 68px;
  line-height: 68px;
}

.info-card-item {
  float: left;
  margin: auto;
  width: 25%;
  vertical-align: middle;
}

.info-card-item-ch {
  margin-left: 30px;
  font-family: "FZLanTingHei-DB-GBK";
  text-align: center;
  font-size: 14px;
  color: #3e454d;
}

.info-card-item-num {
  padding-left: 10px;
  max-width: 90px;
  font-family: "Microsoft YaHei";
  font-size: 14px;
  color: #EB662B;
}

.vertical-line {
  float: right;
  margin-top: 18px;
  width: 1px;
  height: 33px;
  border-right: 1px solid #e8e8e8;
}

#loan-list-bl {
  .el-tabs__item {
    padding: 0 30px;
    font-size: 16px;
    color: #34495e;
    font-family: "FZLanTingHei-DB-GBK";
    &:first-child {
      color: #EB662B;
    }
  }

  .el-tabs__header {
    border-bottom: none;
  }

  .is-active {
    color: #EB662B;
  }

  .el-tabs__active-bar {
    background-color: #EB662B;
  }
  .el-tabs__active-bar {
    bottom: 3px;
    height: 0.1em;
  }
}

</style>



// WEBPACK FOOTER //
// MyGuarantor.vue?1006eb09